export default {
  init() {
    // JavaScript to be fired on the home page

    /* eslint-disable */

	/* eslint-enable */

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
		
	/* eslint-disable */

	// Load all blog posts on page load.
    //On insights category click fire for new results
	  $("#insights-overview").on('change', '#filterbycategory', function(e) {
	    e.preventDefault();
	     
	    var categorySlug = $(this).val();
	    //var author = $('#filterbyauthor').val();

	    $.ajax({
	      type : "post",
	      dataType : "json",
	      url : "../../../../wp-admin/admin-ajax.php",
	      data : { 
	        action: "insights_posts",
	        categorySlug: categorySlug,
	        //author: author
	      },
	      success: function(response) {
	        $('#insights-overview #responsez .insights-grid').html(response);
	        $('html,body').animate({
	          scrollTop: $(".filter-row").offset().top
	        });
			$('.insights-grid-holder .standard-row .card .post-content').matchHeight({byRow:false});
			$(window).resize(function() {
			    $('.insights-grid-holder .standard-row .card .post-content').matchHeight({byRow:false});
			});
	      },
	      error: function (response) {
	        alert("error");
	      },
	    })
	  });

	  //On insights pagination fire for new results
	  $("#insights-overview").on('click', '.page-numbers', function(e) {
	    e.preventDefault();
	   
	    var paged = $('.page-numbers.current').text();  
	    var categorySlug = $('#filterbycategory').val();
	    //var author = $('#filterbyauthor').val();

	    if($(this).hasClass('prev')  ||  $(this).hasClass('next'))
	    {
	      if($(this).hasClass('prev')) 
	      {
	        paged = parseInt(paged) - 1;
	      } 
	      if ($(this).hasClass('next'))
	      {
	        paged = parseInt(paged) + 1;
	      }
	    }
	    else
	    {
	      paged = $(this).text();
	    }

	    $.ajax({
	      type : "post",
	      dataType : "json",
	      url : "../../../../wp-admin/admin-ajax.php",
	      data : { 
	        action: "insights_posts",
	        paged: paged,
	        categorySlug: categorySlug,
	        //author: author
	      },
	      success: function(response) {
	        $('#insights-overview #responsez').html(response);
	        $('html,body').animate({
	          scrollTop: $(".news-row").offset().top
	        });
	      },
	      error: function (response) {
	        alert("error");
	      },
	    })
	  });


	$(document).ready(function(){
	    $('.insights-grid-holder .standard-row .card .post-content').matchHeight({byRow:false});
	});
	$(window).resize(function() {
	    $('.insights-grid-holder .standard-row .card .post-content').matchHeight({byRow:false});
	});

    
    /* eslint-enable */
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/news.js